
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/u/message_app",
      function () {
        return require("private-next-pages/blockquiry_connect/u/message_app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockquiry_connect/u/message_app"])
      });
    }
  